const personProductList = {
	group: '功能介绍_个人版',
	list: [
		{
			id: 21,
			name: 'regulation',
			title: '法规标准库',
			goto: { path: '/info', query: { group: '功能介绍_个人版', id: 21, type: 'content', title: '法规标准库' } },
			class: '',
			content: '标准法规介绍内容'
		},
		{
			id: 24,
			name: 'AI-行业大模型',
			title: 'AI-行业大模型',
			goto: { path: '/info', query: { group: '功能介绍_个人版', id: 24, type: 'content', title: 'AI-行业大模型' } },
			class: '',
			content: 'AI-行业大模型内容'
		},
		{
			id: 26,
			name: 'personalBookshelf',
			title: '个人书架',
			goto: { path: '/info', query: { group: '功能介绍_个人版', id: 26, type: 'content', title: '个人书架' } },
			class: '',
			content: '个人书架内容'
		},
		{
			id: 25,
			name: 'personalBookstore',
			title: '正版图书购买',
			goto: { path: '/info', query: { group: '功能介绍_个人版', id: 25, type: 'content', title: '正版图书购买' } },
			class: '',
			content: '正版图书购买内容'
		}
	]
};

export default personProductList;
